import React from 'react'

const Icon: React.FC<any> = ({ ...props }) => {
  return (
    <svg
      {...props}
      id="order_28px"
      xmlns="http://www.w3.org/2000/svg"
      width="21.904"
      height="28"
      viewBox="0 0 21.904 28"
      fill="#464646"
    >
      <g id="order_28px-2" data-name="order_28px">
        <path
          className="bag__path"
          id="Trazado_28930"
          data-name="Trazado 28930"
          d="M-179.572-749.588h-.9c-1.083-2.419-2.916-4.014-4.993-4.014s-3.91,1.595-4.993,4.014h-.907c-3.464,0-4.36,3.254-5.052,18.344,0,3.269,2.013,5.642,4.785,5.642h12.362a4.457,4.457,0,0,0,3.542-1.77,6.378,6.378,0,0,0,1.212-3.92C-175.211-746.338-176.109-749.588-179.572-749.588Zm-5.9-2.863c1.5,0,2.848,1.115,3.742,2.863h-7.483C-188.317-751.336-186.972-752.451-185.469-752.451Zm8.812,24.395a3.308,3.308,0,0,1-2.643,1.3h-12.337c-2.106,0-3.634-1.889-3.634-4.466.712-15.52,1.786-17.218,3.9-17.218h.478a12.9,12.9,0,0,0-.6,3.909.575.575,0,0,0,.575.575.575.575,0,0,0,.575-.575,11.881,11.881,0,0,1,.64-3.909h8.456a11.881,11.881,0,0,1,.64,3.909.575.575,0,0,0,.575.575.575.575,0,0,0,.575-.575,12.9,12.9,0,0,0-.6-3.909h.475c2.115,0,3.191,1.7,3.9,17.186A5.219,5.219,0,0,1-176.657-728.057Z"
          transform="translate(196.422 753.602)"
        />
      </g>
    </svg>
  )
}

export default Icon
